import Vue from 'vue'
import Router from 'vue-router'
import Error from '@/components/Error'
import Mantenimiento from '@/components/Mantenimiento'
import ErrorSubnet from '@/components/ErrorSubnet'
import Elearning from '@/components/Elearning'
import modalExpired from '@/components/modalExpired'
import { ADMIN_SITE } from '../../viariableProd'
import VueNotify from 'vue-notifyjs'
import routerMessages from '../../config/messages/router.json'
import swal from 'sweetalert'

const SECRET = 'e2ab018979a3c007014c10efb3b0c3fe'
var jwt = require('jsonwebtoken')

// import SalaB from '@/components/SalaB'
// import SalaC from '@/components/SalaC'

// import { URL_FRONT_CLIENT } from "../varibleProd";

Vue.use(VueNotify)
Vue.use(Router)

var verifySession = async (to, from, next) => {
  const token = localStorage.getItem('token')
  // const tokenSesion = sessionStorage.getItem('token')
  const subnet = localStorage.getItem('subnet')
  const mensajes = JSON.parse(localStorage.getItem('msgRouter')) || routerMessages
  const urlTo = to.params.subnet
  if (urlTo === localStorage.getItem('subnet')) {
    if (token) {
    // if (token === tokenSesion) {
      try {
        let decoded = jwt.verify(token, SECRET)
        // console.log(decoded)
        if (decoded.exp < Date.now()) {
          // token is valid, do your stuff
          var currentTime = new Date().getTime() / 1000
          var difcreated = (decoded.exp - decoded.iat) / 60 // obtenemos minutos
          var difexp = (currentTime - decoded.iat) / 60 // obtenemos minutos faltantes
          var dif = difcreated - difexp
          // console.log('Dif:' + dif)
          if (dif < 2) {
            swal({
              // title: 'Sesión Proxima a Expirar',
              title: mensajes[0].valor,
              // text: mensajes[1].valor + 'sesion' + tokenSesion + ',token' + token,
              text: mensajes[1].valor,
              buttons: true,
              successMode: true
            })
              .then((willDelete) => {
                if (willDelete) {
                  // console.log('Obtener el currentime de ' + willDelete)
                  currentTime = new Date().getTime() / 1000
                  difcreated = (decoded.exp - decoded.iat) / 60 // obtenemos minutos
                  difexp = (currentTime - decoded.iat) / 60 // obtenemos minutos faltantes
                  dif = difcreated - difexp
                  // console.log('Valor de dif: ' + dif)
                  if (dif > 0) {
                    var lapso = localStorage.getItem('timetoken')
                    var datos = decoded.data
                    swal(mensajes[2].valor + lapso + ' min')
                    // Add time
                    var userId = {
                      data: datos
                    }
                    var newToken = jwt.sign(userId, SECRET, {
                      // expiresIn: parseInt(lapso) // expires in timetoken
                      expiresIn: parseInt(lapso) * 60
                    })
                    localStorage.setItem('token', newToken)
                    next()
                  } else {
                    localStorage.removeItem('token')
                    next({ path: '/' + subnet })
                  }
                } else {
                  if (dif > 0) {
                    // console.log('Dif:' + dif)
                    swal(mensajes[3].valor)
                    next()
                  } else {
                    // console.log('Dif:' + dif)
                    swal(mensajes[4].valor)
                    localStorage.removeItem('token')
                    next({ path: '/' + subnet })
                  }
                }
              })
          }
          next()
        }
      } catch (err) {
        swal({
          title: mensajes[5].valor,
          text: mensajes[6].valor,
          buttons: true,
          errorMode: true
        })
          .then(data => {
            if (data) {
              next({ path: '/' + localStorage.getItem('subnet') })
            } else {
              next({ path: '/' + localStorage.getItem('subnet') })
            }
          })
      }
    }
    /*
    else {
      swal({
        title: mensajes[7].valor,
        text: mensajes[8].valor,
        buttons: true,
        errorMode: true
      })
        .then(data => {
          next({ path: '/' + subnet })
        })
    }
    */
  } else {
    swal({
      // title: 'Url Invalida',
      title: mensajes[9].valor,
      text: mensajes[10].valor,
      buttons: true,
      errorMode: true
    })
      .then(() => {
        if (subnet) {
          next({ path: '/' + subnet })
        } else {
          next({ path: '/ErrorSubnet/NoSubnet' })
        }
      })
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      /** Se carga componente genérico y ahí se selecciona entre tres posibles fachdas */
      path: '/:subnet',
      name: 'Fachadas',
      component: () => import(/* webpackChunkName: "Fachadas" */ '@/components/Fachadas')
    },
    {
      // Valido
      path: '/:subnet/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "Login" */ '@/components/Login')
    },
    {
      // Valido
      path: '/:subnet/lobby',
      name: 'Lobby',
      component: () => import(/* webpackChunkName: "Lobby" */ '@/components/Lobby'),
      beforeEnter: verifySession
    },
    {
      // Valido
      path: '/:subnet/tl',
      name: 'TL',
      component: () => import(/* webpackChunkName: "TL" */ '@/components/TrabajosLibres'),
      beforeEnter: verifySession
    },
    {
      path: '/:subnet/expo',
      name: 'Expo',
      component: () => import(/* webpackChunkName: "Expo" */ '@/components/Expo'),
      beforeEnter: verifySession
    },
    {
      // Valido
      path: '/:subnet/sala/:id',
      name: 'Sala',
      component: () => import(/* webpackChunkName: "Sala" */ '@/components/Sala'),
      beforeEnter: verifySession
    },
    {
      path: '/:subnet/stand/:id',
      name: 'Stand',
      component: () => import(/* webpackChunkName: "Stand" */ '@/components/Stand'),
      beforeEnter: verifySession
    },
    {
      path: '/:subnet/elearning',
      name: 'Elearning',
      component: Elearning,
      beforeEnter: verifySession
    },
    {
      path: '/:subnet/modalExpired',
      name: 'modalExpired',
      component: modalExpired,
      beforeEnter: verifySession
    },
    {
      path: '*',
      name: 'Not Found',
      component: Error,
      beforeEnter: verifySession
    },
    {
      // Valido
      path: '/:subnet/mantenimiento/:id',
      name: 'Mantenimiento',
      component: Mantenimiento,
      beforeEnter: verifySession
    },
    {
      // Validos
      path: '/ErrorSubnet/:subnet',
      name: 'ErrorSubnet',
      component: ErrorSubnet
      // beforeEnter: verifySession
    },
    {
      path: '/adminsite',
      name: 'adminsite',
      beforeEnter () {
        let paramsURL = localStorage.getItem('token')
        let urlComplete = ADMIN_SITE + 'session/Sesion/' + localStorage.getItem('subnet') + '/' + paramsURL + '/' + localStorage.getItem('userType')
        location.href = urlComplete
      }
    },
    {
      path: '/:subnet/constancia/:email',
      name: 'Constancia',
      component: () => import(/* webpackChunkName: "constancia" */ '@/components/Constancia'),
      props: true
    },
    {
      path: '/:subnet/infografia',
      name: 'Info',
      component: () => import(/* webpackChunkName: "infografia" */ '@/components/Infografia')
    },
    {
      path: '/:subnet/infografia/infografia',
      name: 'Infografia',
      component: () => import(/* webpackChunkName: "info" */ '@/components/Info')
    },
    {
      path: '/:subnet/infografia/TL',
      name: 'Trabajos Libres',
      component: () => import(/* webpackChunkName: "trabajoslibres" */ '@/components/TL')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js